import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useModal } from '../../../context/ModalContext';
import { isLogin } from '../../../utils/auth';
import { isAfterTime } from '../../../utils/eventTime';

const BannerData = [
  // {
  //   img: '/assets/images/mainBanner/MainBanner-presentation.png',
  //   backgroundColor: '#FFEFF3',
  //   link: '엔플랫폼_설명회',
  //   name: '엔플랫폼 세미나',
  // },
  {
    img: '/assets/images/mainBanner/MainBanner-seminar.png',
    backgroundColor: '#000000',
    link: 'https://naver.me/F6nE6oJo',
    // link: '/seminar2509',
    name: '세미나',
  },
  {
    img: '/assets/images/mainBanner/MainBanner-lucky.png',
    backgroundColor: '#273864',
    link: '/promotion/땅집고옥션-럭키-이벤트',
    name: '럭키',
  },
  {
    img: '/assets/images/mainBanner/MainBanner-local.png',
    backgroundColor: '#273864',
    link: '/payment/plan',
    name: '지역권',
  },
  {
    img: '/assets/images/banner/banner_game_main.png',
    backgroundColor: '#022047 ',
    link: '/game',
    name: '밸런스 게임',
  },
  {
    img: '/assets/images/mainBanner/MainBanner-registry.png',
    backgroundColor:
      'radial-gradient(334.65% 109.2% at 100% 64.51%, #053A9B 0%, #1561ED 100%)',
    link: '/board/detail/3811',
    name: '등기부등본',
  },
  {
    img: '/assets/images/mainBanner/MainBanner8.png',
    backgroundColor: '#F7FEFF',
    link: 'https://nplatform.ai/',
    name: '엔플랫폼',
  },
  {
    img: '/assets/images/mainBanner/MainBanner7.png',
    backgroundColor: '#FFEFF3',
    link: '/chat-start',
    name: '챗봇',
  },
  {
    img: '/assets/images/mainBanner/MainBanner-free-3.png',
    backgroundColor: '#F7FEFF',
    link: '/promotion/3일-무료체험-이벤트',
    name: '무료체험',
  },
  {
    img: '/assets/images/mainBanner/MainBanner5.png',
    backgroundColor: '#0B0B0C',
    link: '/quant',
    name: '퀀트',
  },
  {
    img: '/assets/images/mainBanner/MainBanner2.png',
    backgroundColor: '#4078ff',
    link: '/myAlgorithm',
    name: '알고리즘',
  },
];

const Banner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const navigate = useNavigate();

  const { modalDispatch } = useModal();

  const filterBanner = () => {
    // if (isAfterTime()) {
    //   return BannerData.filter((_, i) => i !== 0);
    // }
    return BannerData;
  };

  const banners = filterBanner();

  // useEffect(() => {
  //   if (isPaused) return;

  //   const interval = setInterval(() => {
  //     nextBanner();
  //   }, 3000);

  //   return () => clearInterval(interval);
  // }, [isPaused, currentIndex]);

  // const handlePause = (e: any) => {
  //   e.stopPropagation();
  //   setIsPaused(!isPaused);
  // };

  const nextBanner = (e?: any) => {
    if (e) {
      e.stopPropagation();
    }
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const prevBanner = (e: any) => {
    e.stopPropagation();
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? banners.length - 1 : prevIndex - 1,
    );
  };

  const handleClick = () => {
    // if (
    //   !isLogin() &&
    //   ['알고리즘', '퀀트'].includes(Dummy_Banner[currentIndex].name)
    // ) {
    //   modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
    //   // showAlert('로그인 후 이용해주세요.', navigate);
    //   return;
    // }
    const link = banners[currentIndex].link;

    if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  };

  return (
    <SlideBanner onClick={handleClick}>
      <Inner bg={banners[currentIndex].backgroundColor}>
        <InnerContent>
          <img src={banners[currentIndex].img} alt="" />
        </InnerContent>
        <ButtonBox>
          <ControlButtonBox>
            {/* <StopButton>
              <img
                onClick={handlePause}
                src="/assets/images/icon/banner_stop.png"
                alt=""
              />
            </StopButton> */}
            <ListCountButton>
              <div>{currentIndex + 1}</div>
              <div>/</div>
              <div>{banners.length}</div>
            </ListCountButton>
            <BannerMoveBox>
              <MoveButton>
                <img
                  onClick={prevBanner}
                  src="/assets/images/arrow/24_white_left_Arrow.png"
                  alt=""
                />
              </MoveButton>
              <MoveButton>
                <img
                  onClick={nextBanner}
                  src="/assets/images/arrow/24_white_right_Arrow.png"
                  alt=""
                />
              </MoveButton>
            </BannerMoveBox>
          </ControlButtonBox>
        </ButtonBox>
      </Inner>
    </SlideBanner>
  );
};

export default Banner;

const SlideBanner = styled.div`
  display: flex;
  width: 100%;
  padding: 0 16px;
  flex-direction: column;
  align-items: flex-start;
`;

const Inner = styled.div<{ bg: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: ${(props) => props.bg};
  position: relative;
`;

const InnerContent = styled.div`
  /* width: 328px;
  height: 138px; */
  /* max-height: 170px; */
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  justify-content: right;
  align-items: center;
  position: absolute;
  padding-right: 8px;
  bottom: 0px;
`;

const ControlButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  height: 30px;
`;

const StopButton = styled.div`
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
`;

const MoveButton = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 10px;
  img {
    cursor: pointer;
    width: 17px;
    height: 17px;
  }
`;

const DetailButton = styled.span`
  width: 98px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #222222;
  color: white;
  cursor: pointer;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  border-radius: 9999px;
`;

const BannerMoveBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 41px;
  height: 25px;
  background-color: rgba(0, 0, 0, 0.21);
  border-radius: 9999px;
`;
const ListCountButton = styled.div`
  height: 25px;
  width: 41px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  gap: 3px;
  background: rgba(0, 0, 0, 0.21);
  font-size: 12px;
  color: white;
  font-family: Spoqa Han Sans Neo;
  line-height: 23.2px;
  word-wrap: break-word;
`;
